import { Buffer } from "buffer";
globalThis.Buffer = globalThis.Buffer ?? Buffer;
